import { SET_FILTERED_SEARCH_RESULTS } from "../../actions/setSearchResultAction";
const initialState = {
    tasks: [],
    projects: [],
    Text: '',
};

const searchReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FILTERED_SEARCH_RESULTS:
            return {
                ...state,
                tasks: action.payload.tasks,
                projects: action.payload.projects,
                Text: action.payload.Text,
            };
        default:
            return state;
    }
};

export default searchReducer;